import { render, staticRenderFns } from "./diagnosis.vue?vue&type=template&id=625cd78b&scoped=true&"
import script from "./diagnosis.vue?vue&type=script&lang=js&"
export * from "./diagnosis.vue?vue&type=script&lang=js&"
import style0 from "./diagnosis.vue?vue&type=style&index=0&id=625cd78b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625cd78b",
  null
  
)

export default component.exports